import { TransferState } from '@angular/core';
import { Observable, of } from 'rxjs';
import get from 'lodash/get';
import { TransferableService } from './transferable.service';
import { ApiService } from './api.service';
import { tap } from 'rxjs/operators';

export class TransferableGetApiService extends TransferableService {
  constructor(
    protected api: ApiService,
    protected appConfig: any,
    _platformId: any,
    transferState: TransferState) {
    super(transferState, _platformId);
  }

  protected getWithCaching(apiKey: string, pathKey: string, urlParams?: {},
                           options?: {}, cacheLifetime?: number): Observable<any> {
    const key = `${apiKey}.${pathKey}.${JSON.stringify(urlParams)}.${JSON.stringify(options)}`;

    const data = this.getFromState(key);
    if (data) {
      return of(data);
    }

    return this.api.get(apiKey, pathKey, urlParams, options)
      .pipe(
        tap((res) => {
          this.setToState(key, res, cacheLifetime || get(this.appConfig, 'api.caching.lifetime'));
          return res;
        })
      );
  }
}
